import { Injectable } from '@angular/core';
import { InsuranceType } from '../types/classes/insurance-type.class';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '@aid/shared/services';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InsuranceTypeService extends CrudService<InsuranceType> {
  private insuranceTypesObject = new BehaviorSubject<{
    [id: string]: InsuranceType;
  } | null>(null);

  get url() {
    return 'insurance-types';
  }

  constructor(protected http: HttpClient) {
    super(http);
  }

  afterList() {
    const object: { [id: string]: InsuranceType } = {};
    const insurancesTypes = this.values$.value || [];
    insurancesTypes.forEach(type => {
      object[String(type.id)] = type;
    });
    this.insuranceTypesObject.next(object);
  }

  getInsurancesTypesObject(): { [id: string]: InsuranceType } | null {
    return this.insuranceTypesObject.getValue();
  }

  getInsurancesTypesObject$(): Observable<{
    [id: string]: InsuranceType;
  } | null> {
    return this.insuranceTypesObject.asObservable();
  }

  filterInsuranceTypes(
    insuranceTypes: InsuranceType[],
    organizationInsuranceTypes: { insuranceType: number }[],
    found: boolean
  ) {
    return insuranceTypes.filter(insuranceType => {
      const value = organizationInsuranceTypes.find(
        organizationInsuranceType => {
          return organizationInsuranceType.insuranceType === insuranceType.id;
        }
      );
      return found ? !!value : !value;
    });
  }

  search(search: string): InsuranceType[] | null {
    if (!search) {
      return this.values$.value;
    }

    return this.requireValues().filter(
      insuranceType =>
        (insuranceType.name ?? '').toLowerCase().indexOf(search.toLowerCase()) >
        -1
    );
  }

  private requireValues(): InsuranceType[] {
    const values = this.values$.value;
    if (!values) {
      throw new Error('Insurance types are searched before they are loaded.');
    }
    return values;
  }
}
